<template>
    <div class="bg-ice-blue mb-3 h-full">
        <div class="title-card p-6 md:p-8 relative animated ani-bottom-to-top-transform" @click="dropdown = !dropdown">
            <div>
                <div class="svg-deslocated-left">
                    <slot name="svg" />
                </div>
            </div>
            <div class="text-bigger-size flex items-center">
                <slot name="title" />
            </div>
            <div class="arrow-down-container">
                <div class="arrow-down-blue"/>
            </div>
        </div>
        <p class="px-6 py-6 md:px-8 md:pb-8 bg-white md:bg-transparent text-xl-size animated ani-left-to-right-long" :class="{ 'panel': !dropdown }">
            <slot name="paragraph" />
        </p>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const dropdown = ref(false);
/*
export default {
    data(){
        return {
            dropdown:false
        }
    }
}
*/
</script>

<style lang="postcss" scoped>
:deep() {
    .svg-deslocated-left {
        position: relative;
        left: -15px;
    }

    @media (max-width: 768px) {
        .title-card {
        & svg {
            width: 50px !important;
        }
        @apply flex;
    }
    }

    @media (min-width: 769px) {
        .title-card {
            & svg {
                width: 70px !important;
            }
            @apply flex;
        }

    }

    .bg-ice-blue {
        max-width: 100%;
        word-break: break-word;
        @media (max-width: 767px) {
            @apply text-base;
        }
    }

    .arrow-down-container {
        height: 100%;
        top: 0;
        right: 15px;
        @apply flex items-center absolute;
    }

    .gradient-top, .gradient-bottom {
        display: none !important;
    }

    .text-bigger-size {
        color: #137EC3;
        @apply font-semibold mb-3 md:mb-4;
    }
}
</style>
